import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overflow-y-hidden bg-white h-full flex flex-col items-stretch p-6" }
const _hoisted_2 = { class: "text-gray-800 text-2xl" }
const _hoisted_3 = { class: "text-xl" }
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { class: "flex-grow flex flex-col overflow-y-auto mt-5" }
const _hoisted_6 = { class: "bg-blue-50 rounded-lg flex justify-between py-3 px-4 flex-initial flex-shrink-0" }
const _hoisted_7 = { class: "mt-6 p-5 bg-gray-100 rounded-lg flex flex-col flex-initial flex-shrink-0 space-y-4" }
const _hoisted_8 = { class: "mt-6 flex-initial flex-shrink-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "时间"),
    /*#__PURE__*/_createElementVNode("th", null, "地点")
  ])
], -1)
const _hoisted_10 = { class: "mt-6 space-y-6" }
const _hoisted_11 = { class: "flex justify-between" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 查看课程评价 ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 删除课程 ")
const _hoisted_14 = { class: "flex justify-end" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 关闭 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_number_card_item = _resolveComponent("number-card-item")!
  const _component_info_card_item = _resolveComponent("info-card-item")!
  const _component_f_button = _resolveComponent("f-button")!
  const _component_f_icon = _resolveComponent("f-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.courseInfo.codeId || ''), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.courseInfo.name || ''), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_number_card_item, { title: "学分" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.courseInfo.credit), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_number_card_item, { title: "周学时" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.courseInfo.sectionCount), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_number_card_item, { title: "人数上限" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.courseInfo.maxStudent), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_info_card_item, {
          title: "主讲老师",
          content: _ctx.courseInfo.teachers
        }, null, 8, ["content"]),
        _createVNode(_component_info_card_item, {
          title: "开课院系",
          content: _ctx.courseInfo.department
        }, null, 8, ["content"]),
        _createVNode(_component_info_card_item, {
          title: "校区",
          content: _ctx.courseInfo.campus
        }, null, 8, ["content"]),
        _createVNode(_component_info_card_item, {
          title: "考试形式",
          content: _ctx.courseInfo.examType
        }, null, 8, ["content"]),
        _createVNode(_component_info_card_item, {
          title: "考试时间",
          content: _ctx.courseInfo.examTime
        }, null, 8, ["content"]),
        _createVNode(_component_info_card_item, {
          title: "是否允许期中退课",
          content: _ctx.courseInfo.drop
        }, null, 8, ["content"]),
        _createVNode(_component_info_card_item, {
          title: "备注",
          content: _ctx.courseInfo.remark
        }, null, 8, ["content"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("table", null, [
          _hoisted_9,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseInfo.timeSlots, (ts) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: ts.week + ts.day + ts.section
              }, [
                _createElementVNode("td", null, _toDisplayString(`${ts.week} 周，每周周${ts.day}第 ${ts.section} 节`), 1),
                _createElementVNode("td", null, _toDisplayString(ts.place), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_f_button, {
          shape: "circle",
          type: "primary",
          disabled: ""
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }),
        _createVNode(_component_f_button, {
          shape: "circle",
          type: "danger",
          onClick: _ctx.handleClickDeleteButton
        }, {
          default: _withCtx(() => [
            _createVNode(_component_f_icon, { name: "delete" }),
            _hoisted_13
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_f_button, {
          shape: "circle",
          onClick: _ctx.handleClickCloseButton
        }, {
          default: _withCtx(() => [
            _createVNode(_component_f_icon, { name: "shrink" }),
            _hoisted_15
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}